module.exports = __webpack_public_path__ + "static/media/29BDOS11.225067f0.jpg";